import React, { Component } from 'react';
import KeyboardEventHandler from 'react-keyboard-event-handler';

import closeIcon from './close.svg';

export default class AddAlbum extends Component {
    constructor(props) {
	super(props);
	this.state = {
	    albumName: '',
	    albumAccess: 1
	}
    }

    updateAlbumName = e => this.setState({ albumName: e.target.value });
    updateAlbumAccess = e => this.setState({ albumAccess: e.target.value });

    handleKey = (key, event) => {
	if (key === 'enter') {
	    this.props.addAlbum(this.state.albumName, this.state.albumAccess);
	    event.preventDefault();
	    return;
	}
	if (key === 'esc') {
	    event.preventDefault();
	    this.props.toggleShowAdd();
	    return;
	}
    }

    render() {
	return (<div className='addAlbumPopup'>
		<input type='text' width='30' id='albumName' onChange={this.updateAlbumName} autoFocus/>
		<select id='albumAccess' onChange={this.updateAlbumAccess}>
		{ this.props.access.map(a => <option key={a.id} value={a.id}>{a.name}</option>) }
		</select>
		<button
		type='button'
		onClick={() => this.props.addAlbum(this.state.albumName, this.state.albumAccess)}>
		Add
		</button>
		<img src={closeIcon} className='close' alt='close' onClick={this.props.toggleShowAdd}/>
		<KeyboardEventHandler
		handleKeys={['enter', 'esc']}
		onKeyEvent={this.handleKey}
		handleFocusableElements={true}
		isExclusive={true}/>
		</div>);
    }
}
